module.exports = __webpack_public_path__ + "static/media/iconLostObjectActive.a037e0a2.svg";